import util from './util.js' /*引入 公共工具 模块*/
import drawCommonModel from './drawCommonModel.js'

export default {
    link_3: drawLink_3_Model, 		   /*3列纯文字     1级文字链 绘制 模块*/
    link_3_white: drawLink_3w_Model,   /*3列白底图文   1级文字链 绘制 模块*/
    link_3_pic: drawLink_3p_Model,     /*3列纯图       1级文字链 绘制 模块*/
    link_12_pic: drawLink_12p_Model,   /*3列左1右2纯图 1级文字链 绘制 模块*/
    link_4: drawLink_4_Model,          /*4列纯文字     1级文字链 绘制 模块*/
    link_4_pic: drawLink_4p_Model,     /*4列纯文字     1级文字链 绘制 模块*/
    link_4_white: drawLink_4w_Model,   /*4列白底图文   1级文字链 绘制 模块*/
    link_2Level: drawLink_2Level_Model, /*3或4列纯      2级文字链 绘制 模块*/
    link_13_pic: drawLink_13p_Model,     /*左1右3_纯图      1级文字链 绘制 模块*/
    link_3_pic_word_new:drawLink_3pw_Model,
    link_1:drawLink_1,
    drawLinkSurvery
}

function drawLinkSurvery({title, guide, iconUrl, infoList},moduleIndex) {
    return `<section class="link-survery__wrap visiblereport-luna" data-exposurelog='${JSON.stringify({module_id: 22, extralParam: {name: title}})}'>
        <div class="link-survery__content">
            <i class="link-survery__tag-icon" ${iconUrl ? `style="background-image:url(${iconUrl})"` : ''}></i>
            <h1 class="link-survery__title">${title}</h1>
            <p class="link-survery__guide fold">
                <span class="link-survery__guide-txt">${guide}</span>
                <i class="link-survery__more-icon icon-greaterLabel"></i>
            </p>
            <ul class="link-survery__options-area">
                ${infoList.map(({optionTitle = '', instructionsTxt = '', linkUrl = '', tag = ''} = {},index) => `
                    <li class="link-survery__option__wrap clickreport-luna-vote clickreport" data-exposurelog='${JSON.stringify({name: title})}' data-clickLog="${`${moduleIndex}_${index}_${optionTitle}`}">
                        <a class="link-survery__option__link column-${infoList.length}" href="${linkUrl.replace(/^(http|https):/, '')}&tag=${tag}" data-tag="${tag}">
                            <h2 class="link-survery__option__title">${optionTitle}</h2>
                            ${instructionsTxt ? `<p class="link-survery__option__txt">${instructionsTxt}</p>` : ''}
                        </a>   
                    </li>
                `).join('')}
            </ul>
        </div>
    </section>`
}

/**
 * 左1右3_纯图1级文字链 绘制 模块
 * drawLink_title_Model拼接title模块
 * drawLink_txt_Model拼接纯文字模块
 *
 * @param  {Object} data
 * 详见pageMock.js文件中"modelType":"link_3"对象
 *
 * @return {String}
 * 拼接后的dom
 */
function drawLink_13p_Model(data,cName,moduleIndex){
    cName = cName ? cName : ''
    return `
	<section class="link-model ${cName}">
		${drawCommonModel.drawTitleModel(data,moduleIndex)}
		${data.infoList.map(function(item){
    var txtList = item.filter(function(item,index){return index >0})
    var picItem = item[0]
    var hasPic = !!picItem.imgUrl.trim()
    return `
                    <div class="link-13pic-row">
                        ${hasPic ? `<a class="link-pic-left clickreport-luna-textlink-img clickreport" href="${picItem.linkUrl}&tag=${picItem.tag}" data-clickLog="${`${moduleIndex}_0_`}"><img src="${picItem.imgUrl}" alt=""></a>` : ''}
                        ${hasPic ? drawLink_txt_Model(txtList, 'link-3txt-list link-13pic-list', 3,'//luna.58.com/getDispListById?dispcateid=',moduleIndex) : drawLink_txt_Model(txtList, 'link-3txt-list link-4txt-list', 4,'//luna.58.com/getDispListById?dispcateid=',moduleIndex)}
                        <div class="link-2level-list link-3txt-list link-4txt-list">
							<ul class="swiper-wrapper"></ul>
							<div class="swiper-pagination"></div>
						</div>
                    </div>
					`
}).join('')}
			
	</section>
	`
}

/**
 * 3列纯文字1级文字链 绘制 模块
 * drawLink_title_Model拼接title模块
 * drawLink_txt_Model拼接纯文字模块
 * 
 * @param  {Object} data 
 * 详见pageMock.js文件中"modelType":"link_3"对象
 * 
 * @return {String}      
 * 拼接后的dom
 */
function drawLink_3_Model(data,cName,moduleIndex) {
    cName = cName ? cName : ''
    return `<section class="link-model ${cName}">
			${cName ? drawCommonModel.drawTitleModel(data,moduleIndex) : drawLink_title_Model(data,moduleIndex)}
			${drawLink_txt_Model(data.infoList, 'link-3txt-list', 3,'',moduleIndex)}
		</section>`
}

/**
 * 3列白底图文1级文字链 绘制 模块
 * drawLink_title_Model拼接title模块
 * drawLink_txt_Model拼接纯文字模块
 * 
 * @param  {Object} data 
 * 详见pageMock.js文件中"modelType":"link_3_white"对象
 * 
 * @return {String}      
 * 拼接后的dom
 */
function drawLink_3w_Model(data,cName,moduleIndex){
    cName = cName ? cName : ''
    return `<section class="link-model ${cName}">
			${cName ? drawCommonModel.drawTitleModel(data,moduleIndex) : drawLink_title_Model(data,moduleIndex)}
			<div class="link-3white-list">
				${data.infoList.map((item,index) => `
					<a class="clickreport-luna-textlink-img clickreport" href="${item.linkUrl}&tag=${item.tag}" data-tag="${item.tag}"
                    data-clickLog="${`${moduleIndex}_${index}_${item.txt}`}">
						<p ${getTxtClass(item)}>
							${item.txt}
						</p>
						<img src="${item.imgUrl}" />
						${item.imgLabel.trim() ? `<span class="icon-imgLabel">${item.imgLabel}</span>` : ''}
					</a>
				`).join('')}
			</div>
			${drawLink_txt_Model(data.infoList1, 'link-3txt-list', 3,'',moduleIndex)}
		</section>`
}

/**
 * 3列_图文_文字链模块_新 绘制 模块
 * drawLink_title_Model拼接title模块
 * drawLink_txt_Model拼接纯文字模块
 *
 * @param  {Object} data
 * 详见pageMock.js文件中"modelType":"link_3_white"对象
 *
 * @return {String}
 * 拼接后的dom
 */
function drawLink_3pw_Model(data,cName,moduleIndex){
    cName = cName ? cName : ''
    return `<section class="link-model ${cName}">
			${cName ? drawCommonModel.drawTitleModel(data,moduleIndex) : drawLink_title_Model(data,moduleIndex)}
			<div class="link-3pic-word-list">
				${data.infoList.map((item,index) => `
					<a class="clickreport-luna-textlink-img clickreport" href="${item.linkUrl}&tag=${item.tag}" data-tag="${item.tag}"
                    data-clickLog="${`${moduleIndex}_${index}_${item.txt}`}">
						<div class="imgBox"><img src="${item.imgUrl}" /></div>
						${item.imgLabel.trim() ? `<span class="icon-imgLabel">${item.imgLabel}</span>` : ''}
						<p ${getTxtClass(item)}>
							${item.txt}
						</p>
					</a>
				`).join('')}
			</div>
			${drawLink_txt_Model(data.infoList1, 'link-3txt-list', 3,'',moduleIndex)}
		</section>`
}

/**
 * 3列纯图1级文字链 绘制 模块
 * drawLink_title_Model拼接title模块
 * drawLink_txt_Model拼接纯文字模块
 * 
 * @param  {Object} data 
 * 详见pageMock.js文件中"modelType":"link_3_pic"对象
 * 
 * @return {String}      
 * 拼接后的dom
 */
function drawLink_3p_Model(data,cName,moduleIndex) {
    cName = cName ? cName : ''
    return `<section class="link-model ${cName}">
			${cName ? drawCommonModel.drawTitleModel(data,moduleIndex) : drawLink_title_Model(data,moduleIndex)}
			<div class="link-3pic-list">
				${data.infoList.map((item,index) => `
					<a class="clickreport-luna-textlink-img clickreport" href="${item.linkUrl}&tag=${item.tag}" data-tag="${item.tag}"
                    data-clickLog="${`${moduleIndex}_${index}_`}">
						<img src="${item.imgUrl}" />
					</a>
				`).join('')}
			</div>
			${drawLink_txt_Model(data.infoList1, 'link-3txt-list', 3,'',moduleIndex)}
		</section>`
}

/**
 * 左1右2纯图1级文字链 绘制 模块
 * drawLink_title_Model拼接title模块
 * drawLink_txt_Model拼接纯文字模块
 * 
 * @param  {Object} data 
 * 详见pageMock.js文件中"modelType":"link_12_pic"对象
 * 
 * @return {String}      
 * 拼接后的dom
 */
function drawLink_12p_Model(data,cName,moduleIndex) {
    cName = cName ? cName : ''
    return `<section class="link-model ${cName}">
			${cName ? drawCommonModel.drawTitleModel(data,moduleIndex) : drawLink_title_Model(data,moduleIndex)}
			<div class="link-12pic-list">
				${data.infoList.map((item,index) => `
					<a class="clickreport-luna-textlink-img clickreport" href="${item.linkUrl}&tag=${item.tag}" data-tag="${item.tag}"
                    data-clickLog="${`${moduleIndex}_${index}_`}">
						<img src="${item.imgUrl}" />
					</a>
				`).join('')}
			</div>
			${drawLink_txt_Model(data.infoList1, 'link-3txt-list', 3,'',moduleIndex)}
		</section>`
}

/**
 * 4列纯文字1级文字链 绘制 模块
 * drawLink_title_Model拼接title模块
 * drawLink_txt_Model拼接纯文字模块
 * 
 * @param  {Object} data 
 * 详见pageMock.js文件中"modelType":"link_4"对象
 * 
 * @return {String}      
 * 拼接后的dom
 */
function drawLink_4_Model(data,cName,moduleIndex) {
    cName = cName ? cName : ''
    return `<section class="link-model ${cName}">
			${cName ? drawCommonModel.drawTitleModel(data,moduleIndex) : drawLink_title_Model(data,moduleIndex)}
			${drawLink_txt_Model(data.infoList, 'link-3txt-list link-4txt-list', 4,'',moduleIndex)}
		</section>`
}

/**
 * 4列纯文字1级文字链 绘制 模块
 * drawLink_title_Model拼接title模块
 * drawLink_txt_Model拼接纯文字模块
 * 
 * @param  {Object} data 
 * 详见pageMock.js文件中"modelType":"link_4"对象
 * 
 * @return {String}      
 * 拼接后的dom
 */
function drawLink_4p_Model(data,cName,moduleIndex) {
    cName = cName ? cName : ''
    return `<section class="link-model ${cName}">
		${cName ? drawCommonModel.drawTitleModel(data,moduleIndex) : drawLink_title_Model(data,moduleIndex)}
		<div class="link-4pic-list">
			<div class="picContainer">
				${data.infoList.map((item,index) => `
					<a class="clickreport-luna-textlink-img clickreport" href="${item.linkUrl}&tag=${item.tag}" data-tag="${item.tag}"
                    data-clickLog="${`${moduleIndex}_${index}_`}">
						<img src="${item.imgUrl}" />
					</a>
				`).join('')}
			</div>
		</div>
		${drawLink_txt_Model(data.infoList1, 'link-3txt-list link-4txt-list', 4,'',moduleIndex)}
	</section>`
}

/**
 * 4列白底图文1级文字链 绘制 模块
 * drawLink_title_Model拼接title模块
 * drawLink_txt_Model拼接纯文字模块
 * 
 * @param  {Object} data 
 * 详见pageMock.js文件中"modelType":"link_4_white"对象
 * 
 * @return {String}      
 * 拼接后的dom
 */
function drawLink_4w_Model(data,cName,moduleIndex) {
    cName = cName ? cName : ''
    return `<section class="link-model ${cName}">
			${cName ? drawCommonModel.drawTitleModel(data,moduleIndex) : drawLink_title_Model(data,moduleIndex)}
			<div class="link-3white-list link-4white-list">
				${data.infoList.map((item,index) => `
					<a class="${item.className} clickreport-luna-textlink-img clickreport" href="${item.linkUrl}&tag=${item.tag}" data-tag="${item.tag}"
                    data-clickLog="${`${moduleIndex}_${index}_${item.txt}`}">
						<p ${getTxtClass(item)}>
							${item.txt}
						</p>
						<img src="${item.imgUrl}" />
						${item.imgLabel.trim() ? `<span class="icon-imgLabel">${item.imgLabel}</span>` : ''}
					</a>
				`).join('')}
			</div>
			${drawLink_txt_Model(data.infoList1, 'link-3txt-list link-4txt-list', 4,'',moduleIndex)}
		</section>`
}
/**
 * 1行文字链 绘制 模块
 * @return {String}
 * 拼接后的dom
 */
function drawLink_1(data,moduleIndex){
    return `
		<section class="link-model link-model-new">
			<div class="link-1">
				${data.infoList.map(function (item,index) {
    return `<a class="clickreport-luna-textlink-text clickreport" href="${item.linkUrl}&tag=${item.tag}" data-tag="${item.tag}" data-clickLog="${`${moduleIndex}_${index}_${item.txt}`}">${item.txt}</a>`
})}
			</div>
		</section>
	`
}

/**
 * 判断文字链是否为 热门 最新 标红, 返回类名
 * 
 * @param  {Object} item
 * 详见pageMock.js文件中"modelType":"link_3"的infoList数组中的对象
 * 
 * @return {String}
 * 类名
 */
function getTxtClass(item) {
    var classStr = ''
    if(item.hot){
        classStr += 'class="icon-H'
    }else if(item.new){
        classStr += 'class="icon-N'
    }
    if(item.red){
        classStr += (classStr === '' ? 'class="colorOrange' : ' colorOrange')
    }
    classStr += '"'
    return classStr
}

/**
 * 拼接title模块
 * 
 * @param  {Object} data
 * 详见pageMock.js文件中"modelType":"link_3"对象
 * 
 * @return {String}
 * 拼接后的dom
 */
function drawLink_title_Model(data,moduleIndex) {
    return `<a class="link-title clickreport" ${data.linkUrl.trim() ? `href="${data.linkUrl}&tag=${data.tag}" data-tag="${data.tag}"` : ''} 
    data-clickLog="${moduleIndex}___more">
				<img src="${data.iconUrl}" />
				<p>${data.title}</p>
				${data.guide.trim() ? `<span>${data.guide}<i class="icon-greaterLabel"></i></span>` : ''}
			</a>`
}

/**
 * 拼接 纯文字链 模块
 * 
 * @param  {Object} data
 * 详见pageMock.js文件中"modelType":"link_3"的infoList数组中的对象
 * 
 * @return {String}
 * 拼接后的dom
 */
function drawLink_txt_Model(infoList, className, lineItemNum,dataUrl,moduleIndex) {
	/*行数, 每一行文字链下方都会有一个3级文字链的容器*/
    var line = 0
    dataUrl = dataUrl ? dataUrl : '//luna.58.com/getLv3ByCateid?cateid='
    return `<div class="${className}">
				${infoList.map((item, index) => `
					${(index % lineItemNum === 0 && ++line) ? '' : ''}
					<a class="clickreport clickreport-luna-textlink-text" data-url="${item.show ? `${dataUrl + item.cateid}` : `${item.linkUrl.trim()}&tag=${item.tag.trim()}`}" data-linkurl="${item.linkUrl}&tag=${item.tag}" data-tag="${item.tag}" data-show="${item.show}" data-line="${line}"
                    data-clickLog="${`${moduleIndex}_${index}_${item.txt}`}">
						<p ${getTxtClass(item)}>
							${item.txticonUrl.trim() ? `<img src="${item.txticonUrl}" />` : ''}
							<span>${item.txt}</span>
						</p>
					</a>
					${(index !== 0 && index % lineItemNum === lineItemNum - 1) || (index === infoList.length - 1 && index % lineItemNum !== lineItemNum - 1) ? 
						`<div class="link-2level-list ${className}">
							<ul class="swiper-wrapper"></ul>
							<div class="swiper-pagination"></div>
						</div>` : ''}
				`).join('')}
			</div>`
}

/**
 * 拼接2级文字链模块
 * 
 * @param  {Object} data
 * 接口返回数据
 * @param  {Number} countNum  [description]
 * @param  {String} parentTag [description]
 * @return {[type]}           [description]
 */
var twoLevelLink = {
    countNum: 0,
    parentTag: '',
    parentUrl: ''
}
/**
 * 拼接2级文字链模块
 * 其中2级文字链文案通过cateNameCut()方法处理,截取并使用'/'分割后最长的字段
 * 
 * @param  {Object} data
 * 接口返回数据  详见https://luna.58.com/getLv3ByCateid?cateid=13901
 * 
 * @param  {Object} oneLevelLink
 * 详见bindLinkModel.js中oneLevelLink对象
 * 
 * @return {String} 
 * 拼接后的dom
 */
function drawLink_2Level_Model(data, oneLevelLink,moduleIndex) {
	/*二级文字链前面都加上一个全部的类别, 跳转到当前职位的2级类列表页*/
    data.data.unshift('all')
    twoLevelLink.countNum = oneLevelLink.countNum
    twoLevelLink.parentTag = oneLevelLink._this.data('tag')
    twoLevelLink.parentUrl = oneLevelLink._this.data('linkurl')
    return `${data.data.map((item, index) => `
				${index % twoLevelLink.countNum === 0 ? '<li class="swiper-slide clickreport-luna-textlink-text">' : ''}
				${typeof item !== 'object' ? `<a class="clickreport" href="${twoLevelLink.parentUrl}" data-tag="${twoLevelLink.parentTag}" data-clickLog="${`${moduleIndex}_${index}_全部`}"><p>全部</p></a>` : `
				<a class="clickreport" href="//luna.58.com/list.shtml?plat=m&city=${util.getActiveCityName()}&cate=${item.cate}&-15=20&tag=${twoLevelLink.parentTag}_${item.cate}" data-tag="${twoLevelLink.parentTag}_${item.cate}" data-clickLog="${`${moduleIndex}_${index}_${cateNameCut(item.catename)}`}">
					<p>
						${cateNameCut(item.catename)}
					</p>
				</a>`}
				${index % twoLevelLink.countNum === twoLevelLink.countNum - 1 ? '</li>' : ''}
			`).join('')}`
}



/**
 * 文字链内容截断
 * 规则: 按照'/'分割,取最长的字段
 * 
 * @param  {String} catename 未分割的文字链内容
 * @return {String}          经过处理的文字链内容
 */
function cateNameCut(catename) {
    var catenameArr = catename.split('/')
    catename = catenameArr[0]
    if(catenameArr.length >= 1) {
        catenameArr.sort(function(a, b){
            return b.length-a.length
        })
        catename = catenameArr[0]
    }
    return catename
}
